<template>
    <div class="wrapper__mask-submission">
        <div class="wrapper__container">
            <div class="wrapper__mask-submission__content">
                <div class="wrapper__mask-submission__mask">
                    <img
                        v-if="mask === null"
                        src="images/mask-submission_mask.png"
                        width="420"
                        height="240"
                    />
                    <img
                        v-else
                        :src="mask"
                        width="420"
                        height="240"
                    />

                    <button
                        v-if="!submitted"
                        @click="goBack"
                        class="wrapper__btn wrapper__mask-submission__mask__link"
                        v-trackevent:val="'mask-submission_change-mask_btn'"
                    >&#60; I want to change my mask</button>
                </div>

                <div
                    v-if="!submitted"
                    class="wrapper__mask-submission__form"
                >
                    <form v-on:submit.prevent="submit">
                        <input
                            class="wrapper__mask-submission__form__input"
                            type="email"
                            name="email"
                            v-model="inputs.email"
                            placeholder="Your email"
                        />

                        <input
                            class="wrapper__mask-submission__form__input"
                            type="email"
                            name="parentemail"
                            v-model="inputs.parentemail"
                            placeholder="Parent / Guardian's Email"
                        />

                        <p class="wrapper__mask-submission__form__check1">
                            <input
                                type="checkbox"
                                id="agreement"
                                v-model="inputs.agreement"
                                name="agreement"
                            />
                            <label for="agreement">
                                I agree to the <a @click="open('rules')" v-trackevent:val="'footer_official-rules_overlay'">Official Rules</a>, <a :href="exits.privacypolicy" target="_blank"  v-trackevent:val="'mask-submission_privacy-policy_overlay'">Privacy Policy</a>, and <a :href="exits.termsofservice" target="_blank" v-trackevent:val="'mask-submission_terms-of-service_exit'">Terms of Service</a>.
                            </label>
                        </p>

                        <p class="wrapper__mask-submission__form__check2">
                            <input
                                type="checkbox"
                                id="permission"
                                v-model="inputs.permission"
                                name="permission"
                            />
                            <label for="permission">
                                My parent or guardian knows that i am entering this contest.
                            </label>
                        </p>

                        <button
                            type="submit"
                            v-trackevent:val="'mask-submission_submit-btn'"
                            class="wrapper__btn wrapper__mask-submission__form__button"
                        ></button>

                        <p class="wrapper__mask-submission__form__text">
                            Accepting submissions September 10th <br>
                            through September 21st!
                        </p>
                    </form>
                </div>

                <div
                    v-if="submitted"
                    class="wrapper__mask-submission__submitted"
                >
                    <p v-html="voting"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CONFIG from '@/config';
    import { required, email } from 'vuelidate/lib/validators';
    import Flow from '@/services/flow.service';
    import LoadingSpinner from '@/services/loading-spinner.service';
    import bus from '@/services/bus.service';

    const mustBeTrue = value => value === true;

  export default {

    name: 'MaskSubmission',

    props: ['mask'],

    data() {

        return {
            inputs: {
                email: '',
                parentemail: '',
                agreement: false,
                permission: false
            },
            submitted: false,
            voting: CONFIG.settings.competition.voteBetween,
            exits: CONFIG.settings.exits
        };
    },

    validations: {
        inputs: {
            email: {
                required, email
            },
            parentemail: {
                required, email
            },
            agreement: {
                required, mustBeTrue
            },
            permission: {
                required, mustBeTrue
            }
        }
    },

    methods: {

        open(type) {
            bus.$emit('openOverlay', type);
        },

        toImageFile() {
            const blobBin = atob(this.mask.split(',')[1]);
            const array = [];

            for (let i = 0; i < blobBin.length; i++) {
                array.push(blobBin.charCodeAt(i));
            }

            return new Blob([new Uint8Array(array)], {
                type: 'image/png'
            });
        },

        submit() {
            this.$v.$touch();

            if (this.$v.$invalid) {
                const errors = [];
                let text = '';

                if (this.$v.inputs.email.$invalid) {
                   errors.push('Email');
                }
                if (this.$v.inputs.parentemail.$invalid) {
                   errors.push('Parent / Guardian/\'s Email');
                }
                if (this.$v.inputs.agreement.$invalid) {
                    errors.push('Agreement checkbox');
                }
                if (this.$v.inputs.permission.$invalid) {
                    errors.push('Permission checkbox');
                }

                if (errors.length > 1) {
                    text = 'The following fields are required: ';

                    _.each(errors, (error, index) => {
                        text += error ;

                        if (index === (errors.length - 1)) {
                            text += '.';
                        } else {
                            text += ', ';
                        }
                    });
                } else {
                    text = 'The following field is required: ' + errors[0] + '.';
                }

                this.$snack.danger({
                    text,
                    button: 'Close'
                });
            } else {
                const data = new FormData();
                data.append('email', this.inputs.email);
                data.append('parentemail', this.inputs.parentemail);
                data.append('agreement', this.inputs.agreement);
                data.append('permission', this.inputs.permission);
                data.append('mask', this.toImageFile());

                LoadingSpinner.show();

                Flow.saveEntry(CONFIG.settings.sweepstake.hash, data).then(response => {
                    LoadingSpinner.hide();

                    this.$snack.success({
                        text: 'Your mask has been submitted!',
                        button: 'Ok'
                    });

                    this.submitted = true;
                })
                .catch(error => {
                    let e = 'An error occur, please try again later.';
                    LoadingSpinner.hide();

                    if(
                        error.data.error
                        && error.data.error.length === 1
                        && error.data.error[0] === 'The email is already registered.'
                    ) {
                        e = 'Your email has already submitted a mask!';
                    }

                    this.$snack.danger({
                        text: e,
                        button: 'Close'
                    });
                });
            }
        },

        goBack() {
            this.$emit('changePage', true);
        }
    }
  }
</script>

<style scoped lang="scss">
    ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
        color: #a4252a;
    }
    ::-moz-placeholder { /* Firefox 19+ */
        color: #a4252a;
    }
    :-ms-input-placeholder { /* IE 10+ */
        color: #a4252a;
    }
    :-moz-placeholder { /* Firefox 18- */
        color: #a4252a;
    }

    .wrapper__mask-submission {
        align-items: center;
        justify-content: center;
        display: flex;
        height: 100%;
        position: relative;
        width: 100%;

        &__content {
            width: 100%;
            height: 392px;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
        }

        &__mask {
            float: left;
            text-align: center;
            width: 604px;

            img {
                margin-top: 28px;
            }

            &__link {
                color: #7fac3d;
                font-family: 'Open Sans', sans-serif;
                font-size: 15px;
                font-weight: bold;
                display: block;
                margin: 28px auto 0px;
                text-transform: uppercase;
                text-decoration: none;

                &:hover {
                    color: #ed1c24;
                }
            }
        }

         &__submitted {
            background-image: url(/images/mask-submission_submitted.png);
            height: 311px;
            float: right;
            position: relative;
            width: 396px;

            p {
                color: #FFFFFF;
                font-family: 'Bungee', cursive;
                font-size: 22px;
                line-height: 22px;
                text-align: center;
                margin: 230px auto 0px auto;
                width: 100%;
            }
         }

        &__form {
            background-image: url(/images/mask-submission_form.png);
            background-size: 396px 311px;
            background-repeat: no-repeat;
            height: 392px;
            float: right;
            position: relative;
            width: 396px;

            &__input {
                background-color: #FFFFFF;
                border: none;
                color: #a4252a;
                height: 48px;
                font-family: 'Open Sans', sans-serif;
                font-size: 18px;
                left: 50%;
                text-align: center;
                position: absolute;
                transform: translateX(-50%);
                width: 235px;

                &:nth-of-type(1) {
                    top: 66px;
                }

                &:nth-of-type(2) {
                    top: 126px;
                }
            }

            &__check1,
            &__check2 {
                left: 50%;
                position: absolute;
                transform: translateX(-50%);
                width: 244px;

                label,
                label a {
                    color: #FFFFFF;
                    font-family: 'Open Sans', sans-serif;
                    font-size: 12px;
                }

                a {
                    text-decoration: underline;

                    &:hover {
                        color: #fce239;
                    }
                }
            }

            &__check1 {
                top: 190px;
            }

            &__check2 {
                top: 230px;
            }

            [type="checkbox"]:checked,
            [type="checkbox"]:not(:checked) {
                position: absolute;
                // left: -9999px;
                visibility: hidden;
            }

            [type="checkbox"]:checked + label,
            [type="checkbox"]:not(:checked) + label
            {
                position: relative;
                padding-left: 28px;
                cursor: pointer;
                line-height: 14px;
                display: inline-block;
            }

            [type="checkbox"]:checked + label:before,
            [type="checkbox"]:not(:checked) + label:before {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                width: 18px;
                height: 18px;
                border: 1px solid #ddd;
                border-radius: 100%;
                background: #fff;
            }

            [type="checkbox"]:checked + label:after,
            [type="checkbox"]:not(:checked) + label:after {
                content: '';
                width: 12px;
                height: 12px;
                background: #a4252a;
                position: absolute;
                top: 4px;
                left: 4px;
                border-radius: 100%;
                -webkit-transition: all 0.2s ease;
                transition: all 0.2s ease;
            }

            [type="checkbox"]:not(:checked) + label:after {
                opacity: 0;
                -webkit-transform: scale(0);
                transform: scale(0);
            }

            [type="checkbox"]:checked + label:after {
                opacity: 1;
                -webkit-transform: scale(1);
                transform: scale(1);
            }

            &__button {
                background-image: url('/images/mask-submission_submit.png');
                top: 268px;
                height: 77px;
                left: 50%;
                position: absolute;
                transform: translateX(-50%);
                width: 252px;

                &:hover {
                    background-image: url('/images/mask-submission_submit-hover.png');
                }
            }

            &__text {
                color: #5f9d3e;
                font-family: 'Open Sans', sans-serif;
                font-weight: bold;
                font-size: 16px;
                line-height: 18px;
                left: 50%;
                text-align: center;
                position: absolute;
                bottom: 0px;
                transform: translateX(-50%);
                width: 410px;
            }
        }
    }
</style>
